// Voile sombre + lueur ember/amber posé sur les vidéos/images de fond.
// Le grain "pellicule" ne vit plus ici (nappe plate sur toute la page) —
// il est concentré dans le texte et son halo via .grain-text (index.css),
// appliqué directement sur les titres qui en ont besoin.
//
// Halos plus petits/moins flous sous le breakpoint sm : un filter:blur()
// aussi large (160px) coute cher a recomposer en continu (animate-pulse)
// sur un GPU mobile modeste, en concurrence avec le decodage de la video
// du hero au chargement — repere comme cause probable d'un fige de
// quelques secondes au premier chargement sur telephone.
const HeroOverlay = () => {
  return (
    <div className="absolute inset-0 z-10 pointer-events-none">
      <div className="absolute inset-0 bg-gradient-to-b from-ink-950/70 via-ink-900/50 to-ink-950/90" />

      <div className="absolute inset-0 opacity-25">
        <div className="absolute top-1/4 left-1/4 w-56 h-56 sm:w-96 sm:h-96 bg-ember rounded-full blur-[70px] sm:blur-[160px] animate-pulse" />
        <div
          className="absolute bottom-1/4 right-1/4 w-56 h-56 sm:w-96 sm:h-96 bg-amber rounded-full blur-[70px] sm:blur-[160px] animate-pulse"
          style={{ animationDelay: '1.5s' }}
        />
      </div>

      <div
        className="absolute inset-0"
        style={{ background: 'radial-gradient(ellipse at 50% 45%, transparent 30%, rgba(11,13,14,0.55) 100%)' }}
      />
    </div>
  );
};

export default HeroOverlay;
